<template>
    <DModal
        :show="showModal"
        :title="__('customers.customers.create_cloudpit_customer.title')"
        is-confirm
        @confirm="confirm"
        @close="$emit('close-modal')"
    >
        <template #default>
            <p
                style="padding: 0 25px; text-align: center;"
            >
                <DIcon
                    name="account-question"
                    :size="32"
                /><br><br>

                {{ __('customers.customers.create_cloudpit_customer.explaination') }}
            </p>
            <p style="padding: 0 45px; text-align: center;">
                <DFormCheck
                    id="send_mail"
                    v-model="sendMail"
                    :label="__('customers.customers.create_cloudpit_customer.inform_via_mail') "
                    inline
                />
            </p>
        </template>
    </DModal>
</template>

<script>

export default {
    name: 'CloudpitWelcomeEmailModal',
    props: {
        showModal: {
            type: Boolean,
            default: false
        },
        item: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['close-modal', 'confirm'],
    data () {
        return {
            sendMail: false
        }
    },
    methods: {
        confirm () {
            this.$emit('confirm', { sendMail: this.sendMail, item: this.item })
        }
    }
}
</script>

<style lang="scss" scoped>
.loading {
    padding: 40px 0;
    display: flex;
    justify-content: center;

    & .mdi {
        animation: loadingAnim 0.4s infinite linear;
    }
}
@keyframes loadingAnim {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
